import React from 'react';
import EventTemplateSchedulerPreviewContainer from '../../../../Containers/AdminContainer/EventTemplateScheduler/EventTemplateSchedulerPreview';

const EventTemplateSchedulerPreviewScreen = () => {
  return <EventTemplateSchedulerPreviewContainer />;
};

export default EventTemplateSchedulerPreviewScreen;
